
import { Link } from "react-router-dom";
import { MainNav } from "@/components/MainNav";
import { Button } from "@/components/ui/button";

export const BlogPostNotFound = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <MainNav />
      <div className="flex-1 container mx-auto py-16 px-4 md:px-6 flex flex-col items-center justify-center">
        <h1 className="text-3xl font-bold mb-4">Articolo non trovato</h1>
        <p className="text-muted-foreground mb-8">L'articolo che stai cercando non esiste o potrebbe essere stato rimosso.</p>
        <Button asChild>
          <Link to="/blog">Torna al blog</Link>
        </Button>
      </div>
    </div>
  );
};
